"use client";

import PublicHeader from "@/components/PublicHeader";
import Footer from "@/components/Footer";
import {
  Container,
  Content,
  ContentWrapper,
  Title,
  Section,
  SectionTitle,
  Paragraph,
  List,
  ListItem,
  AlertBox,
} from "./page.styles";

export default function SafetyPage() {
  return (
    <Container>
      <PublicHeader />
      <Content>
        <ContentWrapper>
          <Title>Safety Guidelines</Title>
          <Section>
            <Paragraph>
              At Drizl, safety is our top priority. We&apos;ve established
              comprehensive guidelines to ensure food safety, community trust,
              and a positive experience for everyone.
            </Paragraph>
          </Section>
          <Section>
            <SectionTitle>Food Safety Standards</SectionTitle>
            <List>
              <ListItem>
                Maintain clean and sanitary kitchen environments
              </ListItem>
              <ListItem>
                Follow proper food storage and temperature guidelines
              </ListItem>
              <ListItem>
                Practice safe food handling and preparation techniques
              </ListItem>
              <ListItem>
                Use fresh, quality ingredients from reliable sources
              </ListItem>
              <ListItem>
                Clearly label all allergens and dietary information
              </ListItem>
              <ListItem>Package food securely for safe transportation</ListItem>
              <ListItem>
                Comply with local health and safety regulations
              </ListItem>
            </List>
            <AlertBox>
              <strong>Important:</strong> Artisans must comply with all local
              and state food safety regulations.
            </AlertBox>
          </Section>
          <Section>
            <SectionTitle>For Customers</SectionTitle>
            <List>
              <ListItem>
                Read artisan profiles and reviews before ordering
              </ListItem>
              <ListItem>
                Check meal descriptions for allergen information
              </ListItem>
              <ListItem>
                Communicate any dietary restrictions or allergies
              </ListItem>
              <ListItem>Inspect food upon receipt before consuming</ListItem>
              <ListItem>
                Report any concerns immediately through the app
              </ListItem>
            </List>
          </Section>
          <Section>
            <SectionTitle>For Artisans</SectionTitle>
            <List>
              <ListItem>
                Obtain necessary permits and licenses in your area
              </ListItem>
              <ListItem>
                Maintain food handler certifications if required
              </ListItem>
              <ListItem>
                Follow proper food safety protocols at all times
              </ListItem>
              <ListItem>Accurately list all ingredients and allergens</ListItem>
              <ListItem>Package food to prevent contamination</ListItem>
            </List>
          </Section>
          <Section>
            <SectionTitle>Reporting Concerns</SectionTitle>
            <Paragraph>
              Report any safety concerns to support@drizl.app immediately.
            </Paragraph>
          </Section>
        </ContentWrapper>
      </Content>
      <Footer />
    </Container>
  );
}
